import { React, useState, useEffect } from "react";
// import SearchResults from '../../Utils/SearchResults';
import { Container, Alert } from "reactstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
// import { connect } from "react-redux";
import { Loading } from "../../../loader/Loading";
// import errors from "../../Constants/errors.json";
import RequestDetails from "./RequestDetails";
import * as requestActions from "../../../actions/request";
// import Mapping from "../../Utils/Mapping";
import DocumentTitle from "react-document-title";
// import InfiniteScrollTable from '../../VirtualizedReactInfinite/InfiniteScrollTable';
import InfiniteScrollTable from "../../Common/InfiniteScrollTable";
import { enAPI } from "../../../config";

function ReviewRequest() {
  const dispatch = useDispatch();
  const { requestDetails, requestList, lastKey, deleted_status, success } =
    useSelector((state) => state?.requests);
  const isLoading = useSelector((state) => state?.fetch?.isLoading);
  const error = useSelector((state) => state?.error?.error_obj);
  const app = useSelector((state) => state?.pool?.userPool);
  const authToken = useSelector((state) => state?.auth?.token);

  const [modal, openModal] = useState(false);
  const [property, setProperty] = useState(undefined);

  const successMessage = success;

  function PropertySet(value) {
    clearRequestDetailsFn();
    setProperty(value);
    toggle();
  }

  function toggle() {
    openModal(!modal);
  }

  // const clearRequestListFn = () => {
  //   dispatch({ type: "RESET_ERROR" });
  //   dispatch({ type: "RESET_REQUEST" });
  // };
  // const getRequestListFn = (app) => {
  //   dispatch(requestActions.getRequestList(app));
  // };
  const clearRequestDetailsFn = () => {
    dispatch(requestActions.clearRequestDetails());
  };
  const getRequestDetailsFn = (username) => {
    dispatch(requestActions.getRequestDetails(username));
  };
  const fetchCompleteFn = () => dispatch(requestActions.fetchComplete());
  const errorWhileFetchFn = (err) =>
    dispatch(requestActions.errorWhileFetch(err));
  const setReviewRequestFn = (...props) =>
    dispatch(requestActions.setReviewRequest(...props));

  useEffect(() => {
    dispatch(requestActions.getRequestList(app));
    return () => {
      dispatch({ type: "RESET_ERROR" });
      dispatch({ type: "RESET_REQUEST" });
    };
  }, [dispatch, app]);

  // var errorMessage =
  //   (error && error.code && error.code.message && error.code.message.code) ||
  //   (error && error.message) ||
  //   (error && <Mapping dictionary={errors} word={error.errorPath} />);

  let emailExists =
    error && error.message === "User with given email already exists";

  // console.log(emailExists, errorMessage, error, "Email Exists====>");

  const cols = [
    {
      label: "UserName",
      dataKey: "email",
      sortable: false,
      showSearchBox: true,
      width: "280",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <div
            style={{
              color: "blue",
              cursor: "pointer",
            }}
            onClick={(e) => {
              PropertySet(rowData);
              getRequestDetailsFn(rowData.email);
            }}
          >
            {rowData.email}
          </div>
        );
      },
    },
    {
      label: "Date",
      dataKey: "requestedDate",
      sortable: true,
      showSearchBox: false,
      width: "220",
    },
    {
      label: "Role",
      dataKey: "role",
      sortable: false,
      showSearchBox: false,
      width: "280",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <div
            style={{
              height: "40px",
              width: "282px",
              border: "none",
              backgroundColor: "black !important",
              float: "left",
              // overflowY:'scroll',
              wordWrap: "anywhere",
              overflowX: "hidden",
            }}
          >
            {rowData.role}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DocumentTitle title={`Doorkeeper | Review Request`}></DocumentTitle>
      {/* {error && (
        <Alert color="danger" style={{ textAlign: "center" }}>
          <h5>{errorMessage}</h5>
        </Alert>
      )} */}

      {(!error || emailExists) && (
        <>
          <Container fluid style={{ padding: "0% 15%" }}>
            <h5 style={{ marginLeft: "42%" }}>Review Request</h5>
            {successMessage && !isLoading && (
              <Alert color="success" style={{ marginBottom: "0px" }}>
                <h6>{successMessage}</h6>
              </Alert>
            )}
            {!error &&
              requestList &&
              requestList.length === 0 &&
              !isLoading && (
                <Alert
                  color="info"
                  style={{ textAlign: "center", marginTop: "5%" }}
                >
                  <h5>No records found.</h5>
                </Alert>
              )}
            {modal && requestDetails && (
              <RequestDetails
                MainModal={modal}
                MainToggle={toggle}
                rowDetails={property}
              />
            )}
            {isLoading && <Loading />}

            {requestList && requestList.length > 0 && (
              <InfiniteScrollTable
                data={requestList}
                deleted_status={deleted_status}
                columnData={cols}
                // gridClassName={'gridClass'}
                rowHeight={50}
                page={"review"}
                headerCol={"requestListClass"}
                url={`${enAPI}${app}/getrequests`}
                authToken={authToken}
                // url={'http://localhost:5000/api/idm/admin/DS/getrequests'}
                input={{ lastEvaluatedKey: lastKey }}
                fetchComplete={fetchCompleteFn}
                errorWhileFetch={errorWhileFetchFn}
                setReviewRequest={setReviewRequestFn}
              />
            )}
          </Container>
        </>
      )}
    </>
  );
}

export default ReviewRequest;

// ###############################################################

// import React from 'react';
// // import SearchResults from '../../Utils/SearchResults';
// import { Container, Alert } from 'reactstrap';
// import { connect } from 'react-redux';
// import { Loading } from '../../../loader/Loading';
// import errors from '../../Constants/errors.json';
// import RequestDetails from './RequestDetails';
// import * as requestActions from '../../../actions/request';
// import Mapping from '../../Utils/Mapping';
// import DocumentTitle from 'react-document-title';
// // import InfiniteScrollTable from '../../VirtualizedReactInfinite/InfiniteScrollTable';
// import InfiniteScrollTable from '../../Common/InfiniteScrollTable';
// import { enAPI } from '../../../config';

// class ReviewRequest extends React.Component {
// 	constructor(props) {
// 		super(props);
// 		this.state = {
// 			modal: false,
// 			property: undefined,
// 		};
// 	}

// 	setProperty = (value) => {
// 		this.props.clearRequestDetails();
// 		this.setState({
// 			property: value,
// 		});
// 		this.toggle();
// 	};

// 	toggle = () => {
// 		this.setState({
// 			modal: !this.state.modal,
// 		});
// 	};

// 	componentDidMount = () => {
// 		this.props.getRequestList(this.props.app);
// 	};

// 	componentWillUnmount() {
// 		this.props.clearRequestList();
// 	}

// 	render() {
// 		const { isLoading, error, requestList, success, app } = this.props;
// 		const successMessage = success;
// 		var errorMessage =
// 			(error && error.code && error.code.message && error.code.message.code) || (error && error.message) ||
// 			(error && <Mapping dictionary={errors} word={error.errorPath} />);
// 		const cols = [
// 			{
// 				label: 'UserName',
// 				dataKey: 'email',
// 				sortable: false,
// 				showSearchBox: true,
// 				width: '280',
// 				customCell: props => {
// 					const { rowData } = props;
// 					return (
// 						<div
// 							style={{
// 								color: 'blue',
// 								cursor: 'pointer',
// 							}}
// 							onClick={(e) => {
// 								this.setProperty(rowData);
// 								this.props.getRequestDetails(rowData.email);
// 							}}>
// 							{rowData.email}
// 						</div>

// 					);
// 				}
// 			},
// 			{
// 				label: 'Date',
// 				dataKey: 'requestedDate',
// 				sortable: true,
// 				showSearchBox: false,
// 				width: '220'
// 			},
// 			{
// 				label: 'Role',
// 				dataKey: 'role',
// 				sortable: false,
// 				showSearchBox: false,
// 				width: '280',
// 				customCell: (props) => {
// 					const { rowData } = props;
// 					return (
// 						<div
// 							style={{
// 								height: '40px',
// 								width: '282px',
// 								border: 'none',
// 								backgroundColor: 'black !important',
// 								float: 'left',
// 								// overflowY:'scroll',
// 								wordWrap: 'anywhere',
// 								overflowX: 'hidden'
// 							}}>
// 							{rowData.role}
// 						</div>
// 					)
// 				},
// 			}
// 		]

// 		return (
// 			<>
// 				<DocumentTitle title={`Doorkeeper | Review Request`}></DocumentTitle>
// 				{error && (
// 					<Alert color='danger' style={{ textAlign: 'center' }}>
// 						<h5>{errorMessage}</h5>
// 					</Alert>
// 				)}

// 				{!error && (
// 					<>
// 						<Container fluid style={{ padding: '0% 15%' }}>
// 							<h5 style={{ marginLeft: '42%' }}>Review Request</h5>
// 							{successMessage && !isLoading && (
// 								<Alert color='success' style={{ marginBottom: '0px' }}>
// 									<h6>{successMessage}</h6>
// 								</Alert>
// 							)}
// 							{!error && requestList && requestList.length === 0 && !isLoading && (
// 								<Alert
// 									color='info'
// 									style={{ textAlign: 'center', marginTop: '5%' }}>
// 									<h5>No records found.</h5>
// 								</Alert>
// 							)}
// 							{this.state.modal && this.props.requestDetails && (
// 								<RequestDetails
// 									MainModal={this.state.modal}
// 									MainToggle={this.toggle}
// 									rowDetails={this.state.property}
// 								/>
// 							)}
// 							{isLoading && <Loading />}

// 							{requestList && requestList.length > 0 && (
// 								<InfiniteScrollTable
// 									data={requestList}
// 									deleted_status={this.props.deleted_status}
// 									columnData={cols}
// 									// gridClassName={'gridClass'}
// 									rowHeight={50}
// 									page={'review'}
// 									headerCol={'requestListClass'}
// 									url={`${enAPI}${app}/getrequests`}
// 									authToken={this.props.authToken}
// 									// url={'http://localhost:5000/api/idm/admin/DS/getrequests'}
// 									input={{'lastEvaluatedKey':this.props.lastKey}}
// 									fetchComplete={this.props.fetchComplete}
// 									errorWhileFetch={this.props.errorWhileFetch}
// 									setReviewRequest={this.props.setReviewRequest}
// 								/>
// 							)}
// 						</Container>
// 					</>
// 				)}
// 			</>
// 		);
// 	}
// }

// const mapDistpatchToProps = (dispatch) => {
// 	return {
// 		clearRequestList: () => {
// 			dispatch({ type: 'RESET_ERROR' });
// 			dispatch({ type: 'RESET_REQUEST' });
// 		},
// 		getRequestList: (app) => {
// 			dispatch(requestActions.getRequestList(app));
// 		},
// 		clearRequestDetails: () => {
// 			dispatch(requestActions.clearRequestDetails());
// 		},
// 		getRequestDetails: (username) => {
// 			dispatch(requestActions.getRequestDetails(username));
// 		},
// 		fetchComplete: () => dispatch(requestActions.fetchComplete()),
// 		errorWhileFetch: err => dispatch(requestActions.errorWhileFetch(err)),
// 		setReviewRequest:(...props) => dispatch(requestActions.setReviewRequest(...props))
// 	};
// };

// const mapStateToProps = (state) => {
// 	return {
// 		requestDetails: state.requests.requestDetails,
// 		requestList: state.requests.requestList,
// 		isLoading: state.fetch.isLoading,
// 		error: state.error.error_obj,
// 		app: state.pool.userPool,
// 		authToken: state.auth.token,
// 		success: state.requests.success,
// 		lastKey: state.requests.lastKey,
// 		deleted_status: state.requests.deleted_status
// 	};
// };

// export default connect(mapStateToProps, mapDistpatchToProps)(ReviewRequest);
